import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import about from "../Images/abouthero.png";
import bgteal from "../Images/tealback.png";
import Navbar from "./Header";
import TypewriterText from "./TypeWriterText";


const AboutStory = () => {
  const [missionInView, setMissionInView] = useState(false);
  const [key, setKey] = useState(0);
  const { ref: missionRef, inView } = useInView({
    threshold: 0.3, // Adjust the threshold according to when you want to trigger the animation
    onChange: (inView) => {
      setMissionInView(inView);
    },
  });
  useEffect(() => {
    if (inView) {
      // When the component comes into view, increment the key to force re-render
      setKey((prevKey) => prevKey + 1);
    }
  }, [inView]);

  return (
    <>
      <div className="">
        <Navbar color={"bg-white text-teal-950"} />
      </div>
      <div
        className="lg:h-screen md:h-screen  flex  bg-gradient-to-br from-teal-950 to-teal-700  px-1 md:px-10 lg:px-32 mb-0   items-center justify-center bg-hero overflow-hidden  "
        ref={missionRef}
        key={key}
        style={{
          backgroundImage: `url(${bgteal})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <div className="flex flex-col gap-6 md:gap-0 lg:gap-0 md:flex-row items-center max-w-8xl ">
          <div className="w-full md:w-1/2 lg:pr-32  rounded-lg p-10 ">
            <h2
              className="text-4xl md:text-5xl lg:text-6xl text-center md:text-left text-white leading-tight font-bold"
            >
              Our <span className="inline text-4xl md:text-5xl lg:text-6xl text-teal-200">Story </span> 
            </h2>
            <p className="mt-6 md:mt-10 text-lg md:text-lg lg:text-xl   text-center md:text-left text-white ">
              Solvexa Marketing, founded by Adnan Taj and led by Marrium Bilal,
              delivers innovative marketing solutions, including social media
              management, digital marketing, branding, SEO, video editing, and
              web development. They specialize in connecting brands with their
              audience through creative and strategic approaches.
            </p>
          </div>
          <div className="w-full md:w-1/2 flex justify-center md:justify-center lg:justify-center ">
            <img
              src={about}
              alt="About"
              ref={missionRef}
              className={`w-[350px] h-[250px] mt-2 lg:mt-3 md:mt-3  md:w-[500px] md:h-[400px] lg:w-[600px] lg:h-[500px]   duration-500 ease-in-out hidden lg:block md:block ${
                missionInView ? "scale-100  opacity-100" : "opacity-75 scale-75"
              }`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutStory;
